import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";

const getAnnouncementInitialValues = (localeCodes, showData = null) => {
  const data = showData?.data;
  return {
    text: data?.text || "",
    type: data?.type || "",
    page: data?.page || "",
    is_closable: data?.is_closable ?? BOOLEAN_OPTIONS.NO,
    name: data?.name || "",
    sport_type: data?.sport_type || "",
    sport_id: data?.sport_id || "",
    localizations: localeCodes.reduce((acc, localeCode) => {
      acc[localeCode] =
        showData?.data?.localization_contents?.[localeCode] ?? "";
      return acc;
    }, {}),
    status: data?.status || STATUS.INACTIVE,
  };
};

export default getAnnouncementInitialValues;
